import "./BottomNavbar.scss";
import React, { useState, useEffect, useRef } from "react";
import { useLocation, useHistory } from "react-router-dom";
import MyContext from "../MyContext.jsx";

const Footer = () => {
  const location = useLocation();
  const history = useHistory();
  const [activeTab, setActiveTab] = useState(location.pathname);
  const navRef = useRef(null);
  const shuttleRef = useRef(null);

  useEffect(() => {
    setActiveTab(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    if (navRef.current && shuttleRef.current) {
      const activeButton = navRef.current.querySelector(".nav_button.active");
      if (activeButton) {
        const left = activeButton.offsetLeft + activeButton.offsetWidth / 2 - shuttleRef.current.offsetWidth / 2;
        shuttleRef.current.style.left = `${left}px`;
      }
    }
  }, [activeTab]);

  useEffect(() => {
    const handleKeyboardShow = () => {
      document.querySelector(".bottom_nav_placeholder").style.display = "none";
      document.body.classList.add("keyboard-visible");
    };

    const handleKeyboardHide = () => {
      document.querySelector(".bottom_nav_placeholder").style.display = "block";
      document.body.classList.remove("keyboard-visible");
    };

    if (window.cordova) {
      window.addEventListener("keyboardWillShow", handleKeyboardShow);
      window.addEventListener("keyboardDidHide", handleKeyboardHide);
    }

    return () => {
      if (window.cordova) {
        window.removeEventListener("keyboardWillShow", handleKeyboardShow);
        window.removeEventListener("keyboardDidHide", handleKeyboardHide);
      }
    };
  }, []);

  const navItems = [
    { path: "/home", icon: "fas fa-home", label: "Home" },
    { path: "/salesorders", icon: "fas fa-clipboard-list", label: "Salesorders" },
    { path: "/dayplan", icon: "fas fa-calendar-alt", label: "Day Plan" },
    { path: "/leads", icon: "fas fa-headset", label: "Leads" },
    { path: "/dashboard", icon: "fas fa-th", label: "Dashboard" },
  ];

  if (location.pathname === "/android_asset/www/index.html" || location.pathname === "/") {
    return null;
  }

  return (
    <MyContext.Consumer>
      {(context) => (
        <div className="bottom_nav_placeholder">
          <div className="bottom_nav_container noselect" ref={navRef}>
            <div className="shuttle" ref={shuttleRef}></div>
            <div className="bottom_nav">
              {navItems.map((item) => (
                <div
                  key={item.path}
                  className={`grid_item nav_button ${activeTab === item.path ? "active" : ""}`}
                  onClick={() => history.push(item.path)}
                >
                  <i className={item.icon}></i>
                  <div>{item.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </MyContext.Consumer>
  );
};

export default Footer;
